import React from "react";
import { Box } from "@mui/material";

interface LoadingSpinnerProps {
    size?: number;
    thickness?: number;
}

const LoadingSpinner = ({ size = 24, thickness = 4 }: LoadingSpinnerProps): React.ReactElement => {
    const r = (size - thickness) / 2;
    const circumference = 2 * Math.PI * r;
    const center = size / 2;

    return (
        <Box sx={{ textAlign: `center` }}>
            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ display: `inline-block` }}>
                <circle
                    cx={center}
                    cy={center}
                    r={r}
                    fill="none"
                    stroke="currentColor"
                    strokeOpacity={0.2}
                    strokeWidth={thickness}
                />
                <circle
                    cx={center}
                    cy={center}
                    r={r}
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={thickness}
                    strokeLinecap="round"
                    strokeDasharray={`${circumference * 0.33} ${circumference * 0.67}`}
                >
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from={`0 ${center} ${center}`}
                        to={`360 ${center} ${center}`}
                        dur="1.2s"
                        repeatCount="indefinite"
                    />
                </circle>
            </svg>
        </Box>
    );
};

export default LoadingSpinner;
